var _g, _g2, _g3, _g4, _path, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 109,
    viewBox: "0 0 110 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Home dictionary 1",
    clipPath: "url(#clip0_1385_144947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1385_144947",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 0,
    width: 64,
    height: 69
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "8e58ace740"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.0317 0H82.8649V68.016H19.0317V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1385_144947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M82.74 18.8641V51.3995L71.2041 46.0721V0.0888672L82.74 18.8641ZM19.0317 44.4564V67.8392L49.8526 62.8445V36.1997L59.1119 40.4711V21.0782L39.0639 32.7696L19.0317 44.4564Z",
    fill: "#BD9479"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1385_144947",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 0,
    width: 54,
    height: 80
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "13d4cb0a0a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M38.9741 0H91.1897V79.9333H38.9741V0Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1385_144947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M91.1898 55.2758V73.2687L67.6594 77.0508V65.5116L58.5954 61.4286L58.416 61.3457V78.5564L49.864 79.9336V36.1997L59.1234 40.4711V21.0782L39.064 32.7696V18.8641L71.2042 0.0888672V46.0528L82.74 51.3802L91.1898 55.2758Z",
    fill: "#DDC1A7"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M67.659 65.5117V77.0509L58.4155 78.5406V61.3311L58.5949 61.4128L67.659 65.5117Z",
    fill: "#5B4F47"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M3.69222 87.6501V91.8148H2.46143V83.4082H3.69222V87.1687H7.53901V83.4082H8.7698V91.8148H7.53901V87.6501H3.69222Z",
    fill: "#5B4F47"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.6215 83.2539C15.7228 83.2539 16.6334 83.6172 17.351 84.3439C18.0708 85.0683 18.4319 86.0731 18.4319 87.3596C18.4319 88.1896 18.2877 88.9162 18.0005 89.5396C17.7121 90.1606 17.3351 90.6387 16.8696 90.9747C15.9635 91.6378 14.9643 91.9694 13.8721 91.9694C12.7821 91.9694 11.8783 91.6038 11.1607 90.8703C10.4454 90.1379 10.0889 89.1286 10.0889 87.841C10.0889 87.1722 10.1842 86.5693 10.375 86.0334C10.5657 85.4952 10.8155 85.0558 11.1244 84.7163C11.4332 84.378 11.7897 84.0941 12.1962 83.867C12.941 83.4583 13.7495 83.2539 14.6215 83.2539ZM12.069 90.3662C12.2893 90.7386 12.5868 91.0292 12.9592 91.2382C13.3316 91.4448 13.7608 91.547 14.249 91.547C14.7361 91.547 15.1687 91.4244 15.548 91.1791C15.9295 90.9339 16.2258 90.6137 16.4381 90.2163C16.8707 89.4204 17.0876 88.5654 17.0876 87.6502C17.0876 86.5239 16.8616 85.619 16.4109 84.9343C15.9136 84.1622 15.0892 83.7762 13.9357 83.7762C13.1148 84.0646 12.4925 84.5596 12.069 85.2613C11.6444 85.9641 11.4332 86.7601 11.4332 87.6502C11.4332 88.7346 11.6444 89.6395 12.069 90.3662Z",
    fill: "#5B4F47"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M24.2345 89.821L27.0413 83.4082H28.3357L28.8035 91.8148H27.5091L27.1685 84.589H27.114L23.9166 91.8148H23.7395L20.6012 84.8797H20.5513L20.2061 91.8148H19.6475L20.1198 83.4082H21.3006L24.2345 89.821Z",
    fill: "#5B4F47"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M30.7842 91.8148V83.4082H35.8754L35.7482 84.2575L33.3866 83.8669C32.971 83.8669 32.5146 83.9384 32.015 84.0804V87.1687H34.8353V87.6501H32.015V91.3561L35.9526 90.9655L35.8254 91.8148H30.7842Z",
    fill: "#5B4F47"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M40.5845 91.8148V83.4082H42.9825C43.9816 83.4082 44.8832 83.6205 45.6893 84.044C46.1185 84.2654 46.4943 84.5413 46.8156 84.8706C47.1392 85.201 47.3981 85.6223 47.5923 86.1332C47.7853 86.6453 47.8829 87.2141 47.8829 87.8409C47.8829 88.7378 47.6581 89.494 47.2108 90.1117C46.3899 91.2471 45.0603 91.8148 43.2232 91.8148H40.5845ZM42.9688 91.3834C44.043 91.3834 44.9059 91.0677 45.5576 90.4342C46.2116 89.7983 46.5386 88.8662 46.5386 87.6365C46.5386 86.6896 46.2797 85.8789 45.762 85.2067C45.2465 84.5323 44.5789 84.0849 43.7591 83.8669C43.0199 83.8669 42.3762 83.9555 41.8289 84.1303V91.2698C42.098 91.3459 42.4783 91.3834 42.9688 91.3834Z",
    fill: "#5B4F47"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M50.4861 83.4082V91.8148H49.3188V83.4082H50.4861Z",
    fill: "#5B4F47"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M56.3873 91.9694C55.0759 91.9694 53.9711 91.614 53.0719 90.9021C52.1749 90.1913 51.7275 89.1706 51.7275 87.841C51.7275 87.0632 51.8751 86.3695 52.1726 85.7609C52.469 85.1501 52.8584 84.6698 53.3398 84.3212C54.314 83.6104 55.4074 83.2539 56.6189 83.2539C57.3206 83.2539 58.0518 83.3811 58.8125 83.6354L58.6854 84.5029C58.288 84.3337 57.9791 84.2065 57.7589 84.1214C57.1253 83.892 56.4872 83.7762 55.8423 83.7762C54.9544 83.9794 54.272 84.42 53.794 85.0978C53.3149 85.7768 53.0764 86.6227 53.0764 87.6366C53.0764 88.881 53.4011 89.8416 54.0529 90.516C54.7035 91.1882 55.5618 91.5243 56.628 91.5243C57.6964 91.5243 58.4924 91.2961 59.0169 90.8385V91.5334C58.2902 91.824 57.4137 91.9694 56.3873 91.9694Z",
    fill: "#5B4F47"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M63.1577 91.8148H61.9224V84.0168C61.634 83.9509 61.3467 83.9169 61.0594 83.9169L59.3472 84.312L59.27 83.4082H65.81L65.7464 84.312L64.0206 83.9169C63.7322 83.9169 63.4449 83.9509 63.1577 84.0168V91.8148Z",
    fill: "#5B4F47"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M67.9924 83.4082V91.8148H66.8252V83.4082H67.9924Z",
    fill: "#5B4F47"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M73.8441 83.2539C74.9455 83.2539 75.8561 83.6172 76.5736 84.3439C77.2935 85.0683 77.6546 86.0731 77.6546 87.3596C77.6546 88.1896 77.5104 88.9162 77.2231 89.5396C76.9347 90.1606 76.5578 90.6387 76.0922 90.9747C75.1862 91.6378 74.187 91.9694 73.0947 91.9694C72.0047 91.9694 71.1009 91.6038 70.3834 90.8703C69.668 90.1379 69.3115 89.1286 69.3115 87.841C69.3115 87.1722 69.4069 86.5693 69.5976 86.0334C69.7884 85.4952 70.0382 85.0558 70.347 84.7163C70.6559 84.378 71.0124 84.0941 71.4189 83.867C72.1637 83.4583 72.9721 83.2539 73.8441 83.2539ZM71.2917 90.3662C71.512 90.7386 71.8094 91.0292 72.1819 91.2382C72.5543 91.4448 72.9835 91.547 73.4717 91.547C73.9588 91.547 74.3914 91.4244 74.7706 91.1791C75.1521 90.9339 75.4485 90.6137 75.6608 90.2163C76.0934 89.4204 76.3102 88.5654 76.3102 87.6502C76.3102 86.5239 76.0843 85.619 75.6335 84.9343C75.1362 84.1622 74.3119 83.7762 73.1583 83.7762C72.3374 84.0646 71.7152 84.5596 71.2917 85.2613C70.867 85.9641 70.6559 86.7601 70.6559 87.6502C70.6559 88.7346 70.867 89.6395 71.2917 90.3662Z",
    fill: "#5B4F47"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M85.3597 91.9556H85.1417L79.5827 84.9978H79.5327V91.8148H78.9741V83.4082H79.9142L84.7511 89.5167H84.8011V83.4082H85.3597V91.9556Z",
    fill: "#5B4F47"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M86.374 91.8151L90.1436 83.2041H90.3344L94.1085 91.8151H92.7233L91.7695 89.5306H87.9999L87.0598 91.8151H86.374ZM88.1907 89.0447H91.5697L89.8893 84.9345L88.1907 89.0447Z",
    fill: "#5B4F47"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M96.367 87.8V91.8148H95.1226V83.4082H97.8657C98.7196 83.4082 99.419 83.599 99.964 83.9805C100.511 84.362 100.786 84.8649 100.786 85.4883C100.786 86.1094 100.568 86.5999 100.132 86.9598C99.696 87.3174 99.1056 87.5638 98.3608 87.7001L101.762 91.8148L100.291 91.992L97.3434 87.8H96.367ZM96.367 87.423H97.1799C98.7025 87.423 99.4644 86.8224 99.4644 85.62C99.4644 85.4145 99.4122 85.1863 99.31 84.9342C99.1158 84.3983 98.7014 84.0463 98.0656 83.876C97.4899 83.876 96.9233 83.9487 96.367 84.094V87.423Z",
    fill: "#5B4F47"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M106.179 91.8148H104.948V88.6902L102.078 83.4082H103.463L105.811 88.236L108.009 83.4082H108.64L106.179 88.6266V91.8148Z",
    fill: "#5B4F47"
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M18.6336 101.385H17.6072V99.2094H16.0948V101.385H15.0684V96.3027H16.0948V98.3601H17.6072V96.3027H18.6336V101.385Z",
    fill: "#5B4F47"
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M23.4625 99.3C23.4625 99.9813 23.3001 100.511 22.9765 100.89C22.6552 101.265 22.209 101.453 21.6367 101.453C21.0645 101.453 20.6149 101.267 20.2879 100.894C19.9631 100.522 19.7996 99.9994 19.7974 99.3273V98.4553C19.7974 97.7592 19.9575 97.2154 20.2788 96.8248C20.6024 96.4319 21.052 96.2344 21.6277 96.2344C22.1931 96.2344 22.6382 96.4274 22.9629 96.8112C23.2899 97.1961 23.4557 97.7365 23.4625 98.4325V99.3ZM22.4315 98.4507C22.4315 97.9909 22.3657 97.6502 22.2362 97.4288C22.1057 97.2052 21.9024 97.0928 21.6277 97.0928C21.3552 97.0928 21.1531 97.2006 21.0236 97.4152C20.893 97.6309 20.8261 97.9579 20.8238 98.3962V99.3C20.8238 99.7451 20.8885 100.074 21.0191 100.286C21.1519 100.494 21.3574 100.599 21.6367 100.599C21.9024 100.599 22.1011 100.497 22.2317 100.29C22.3611 100.085 22.4281 99.7655 22.4315 99.3318V98.4507Z",
    fill: "#5B4F47"
  }))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M27.9317 96.3027V99.8225C27.9249 100.349 27.7784 100.754 27.4911 101.035C27.2061 101.314 26.7963 101.453 26.2603 101.453C25.7176 101.453 25.3032 101.312 25.0159 101.031C24.7275 100.747 24.5845 100.335 24.5845 99.7953V96.3027H25.6154V99.7998C25.6154 100.088 25.662 100.294 25.7562 100.417C25.8493 100.542 26.0174 100.604 26.2603 100.604C26.5056 100.604 26.6736 100.544 26.7645 100.422C26.8553 100.298 26.9019 100.097 26.9053 99.818V96.3027H27.9317Z",
    fill: "#5B4F47"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M31.2854 100.049C31.2854 99.8439 31.232 99.6883 31.1264 99.5816C31.0197 99.476 30.8267 99.3659 30.5451 99.25C30.0364 99.0593 29.6697 98.8345 29.446 98.5733C29.2246 98.3133 29.1145 98.0056 29.1145 97.6514C29.1145 97.2245 29.2655 96.8827 29.5686 96.625C29.8707 96.3649 30.2567 96.2344 30.7268 96.2344C31.0379 96.2344 31.3149 96.3002 31.5579 96.4297C31.8031 96.5602 31.9905 96.7464 32.1211 96.9883C32.2539 97.2279 32.3209 97.4992 32.3209 97.8012H31.299C31.299 97.5651 31.2468 97.3857 31.1446 97.2608C31.0447 97.137 30.8993 97.0746 30.7086 97.0746C30.5292 97.0746 30.3884 97.1279 30.2862 97.2335C30.1863 97.3403 30.1363 97.4822 30.1363 97.6605C30.1363 97.8001 30.192 97.9273 30.3044 98.042C30.4157 98.1544 30.6144 98.2713 30.8993 98.3917C31.3955 98.5711 31.7555 98.7902 31.9803 99.0502C32.2039 99.3114 32.3163 99.6429 32.3163 100.045C32.3163 100.488 32.1756 100.833 31.894 101.08C31.6124 101.329 31.2286 101.453 30.7449 101.453C30.4179 101.453 30.1193 101.386 29.8502 101.253C29.58 101.117 29.3688 100.924 29.2144 100.672C29.0622 100.421 28.9873 100.124 28.9873 99.7814H30.0183C30.0183 100.075 30.0739 100.289 30.1863 100.422C30.301 100.556 30.4872 100.622 30.7449 100.622C31.1049 100.622 31.2854 100.431 31.2854 100.049Z",
    fill: "#5B4F47"
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_57"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M34.4971 101.385H33.4707V96.3027H34.4971V101.385Z",
    fill: "#5B4F47"
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M39.3392 101.385H38.3128L36.814 98.0513V101.385H35.7876V96.3027H36.814L38.3173 99.6409V96.3027H39.3392V101.385Z",
    fill: "#5B4F47"
  }))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M44.0486 100.808C43.8487 101.024 43.6046 101.185 43.3173 101.294C43.0324 101.399 42.719 101.453 42.3772 101.453C41.7925 101.453 41.3383 101.273 41.0147 100.912C40.69 100.549 40.5242 100.022 40.5151 99.3318V98.4189C40.5151 97.7172 40.6673 97.1779 40.9738 96.8021C41.2793 96.424 41.7255 96.2344 42.3136 96.2344C42.8643 96.2344 43.2787 96.3706 43.5581 96.6431C43.8396 96.9134 44.0031 97.3403 44.0486 97.9239H43.0494C43.0221 97.6003 42.954 97.3789 42.845 97.2608C42.7383 97.1427 42.5725 97.0837 42.3454 97.0837C42.0661 97.0837 41.864 97.1859 41.7368 97.388C41.6119 97.5912 41.5484 97.9137 41.5461 98.3553V99.2773C41.5461 99.7405 41.6142 100.079 41.7505 100.29C41.889 100.499 42.1183 100.603 42.4363 100.603C42.6384 100.603 42.8019 100.563 42.9268 100.481L43.0176 100.417V99.4862H42.3V98.7096H44.0486V100.808Z",
    fill: "#5B4F47"
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M50.7201 99.6906C50.6951 100.272 50.5339 100.711 50.2341 101.008C49.9344 101.305 49.5097 101.453 48.9625 101.453C48.3868 101.453 47.9463 101.265 47.6408 100.89C47.3343 100.511 47.1821 99.971 47.1821 99.2682V98.4144C47.1821 97.715 47.3388 97.1779 47.6545 96.8021C47.9724 96.424 48.4129 96.2344 48.9761 96.2344C49.5302 96.2344 49.9503 96.3888 50.2387 96.6976C50.5259 97.0065 50.6894 97.4504 50.7292 98.0283H49.6982C49.6891 97.6718 49.6324 97.4243 49.5302 97.288C49.4303 97.1518 49.2452 97.0837 48.9761 97.0837C48.7036 97.0837 48.5094 97.1813 48.3948 97.3743C48.2789 97.5651 48.2188 97.8807 48.2131 98.319V99.2818C48.2131 99.7848 48.2687 100.131 48.3811 100.322C48.4924 100.51 48.6866 100.603 48.9625 100.603C49.2316 100.603 49.4178 100.539 49.5211 100.408C49.6233 100.275 49.6823 100.036 49.6982 99.6906H50.7201Z",
    fill: "#5B4F47"
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_69"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M55.3609 99.3C55.3609 99.9813 55.1986 100.511 54.875 100.89C54.5536 101.265 54.1074 101.453 53.5352 101.453C52.9629 101.453 52.5133 101.267 52.1863 100.894C51.8616 100.522 51.6981 99.9994 51.6958 99.3273V98.4553C51.6958 97.7592 51.8559 97.2154 52.1772 96.8248C52.5008 96.4319 52.9504 96.2344 53.5261 96.2344C54.0915 96.2344 54.5366 96.4274 54.8613 96.8112C55.1883 97.1961 55.3541 97.7365 55.3609 98.4325V99.3ZM54.33 98.4507C54.33 97.9909 54.2641 97.6502 54.1347 97.4288C54.0041 97.2052 53.8009 97.0928 53.5261 97.0928C53.2536 97.0928 53.0515 97.2006 52.9221 97.4152C52.7915 97.6309 52.7245 97.9579 52.7222 98.3962V99.3C52.7222 99.7451 52.7869 100.074 52.9175 100.286C53.0504 100.494 53.2559 100.599 53.5352 100.599C53.8009 100.599 53.9996 100.497 54.1301 100.29C54.2596 100.085 54.3266 99.7655 54.33 99.3318V98.4507Z",
    fill: "#5B4F47"
  }))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_72"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M60.0755 101.385H59.0491L57.5503 98.0513V101.385H56.5239V96.3027H57.5503L59.0536 99.6409V96.3027H60.0755V101.385Z",
    fill: "#5B4F47"
  }))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_75"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M63.4768 100.049C63.4768 99.8439 63.4234 99.6883 63.3178 99.5816C63.2111 99.476 63.0181 99.3659 62.7365 99.25C62.2278 99.0593 61.8611 98.8345 61.6374 98.5733C61.416 98.3133 61.3059 98.0056 61.3059 97.6514C61.3059 97.2245 61.4569 96.8827 61.76 96.625C62.0621 96.3649 62.4481 96.2344 62.9182 96.2344C63.2293 96.2344 63.5063 96.3002 63.7493 96.4297C63.9945 96.5602 64.1819 96.7464 64.3125 96.9883C64.4453 97.2279 64.5123 97.4992 64.5123 97.8012H63.4904C63.4904 97.5651 63.4382 97.3857 63.336 97.2608C63.2361 97.137 63.0908 97.0746 62.9 97.0746C62.7206 97.0746 62.5798 97.1279 62.4776 97.2335C62.3777 97.3403 62.3278 97.4822 62.3278 97.6605C62.3278 97.8001 62.3834 97.9273 62.4958 98.042C62.6071 98.1544 62.8058 98.2713 63.0908 98.3917C63.5869 98.5711 63.9469 98.7902 64.1717 99.0502C64.3953 99.3114 64.5078 99.6429 64.5078 100.045C64.5078 100.488 64.367 100.833 64.0854 101.08C63.8038 101.329 63.42 101.453 62.9363 101.453C62.6093 101.453 62.3107 101.386 62.0416 101.253C61.7714 101.117 61.5602 100.924 61.4058 100.672C61.2536 100.421 61.1787 100.124 61.1787 99.7814H62.2097C62.2097 100.075 62.2653 100.289 62.3777 100.422C62.4924 100.556 62.6786 100.622 62.9363 100.622C63.2963 100.622 63.4768 100.431 63.4768 100.049Z",
    fill: "#5B4F47"
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M68.9234 96.3027V99.8225C68.9166 100.349 68.7701 100.754 68.4828 101.035C68.1978 101.314 67.788 101.453 67.252 101.453C66.7093 101.453 66.2949 101.312 66.0076 101.031C65.7192 100.747 65.5762 100.335 65.5762 99.7953V96.3027H66.6071V99.7998C66.6071 100.088 66.6537 100.294 66.7479 100.417C66.841 100.542 67.0091 100.604 67.252 100.604C67.4973 100.604 67.6653 100.544 67.7562 100.422C67.847 100.298 67.8936 100.097 67.897 99.818V96.3027H68.9234Z",
    fill: "#5B4F47"
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_81"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M71.1548 100.531H72.9533V101.385H70.1284V96.3027H71.1548V100.531Z",
    fill: "#5B4F47"
  }))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M77.2699 97.1566H76.0119V101.385H74.9809V97.1566H73.7456V96.3027H77.2699V97.1566Z",
    fill: "#5B4F47"
  }))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M80.7114 100.345H79.3125L79.04 101.385H77.9546L79.5442 96.3027H80.4798L82.0784 101.385H80.9839L80.7114 100.345ZM79.5351 99.491H80.4843L80.012 97.6789L79.5351 99.491Z",
    fill: "#5B4F47"
  }))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M86.5345 101.385H85.5081L84.0093 98.0513V101.385H82.9829V96.3027H84.0093L85.5126 99.6409V96.3027H86.5345V101.385Z",
    fill: "#5B4F47"
  }))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_93"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M91.08 97.1566H89.822V101.385H88.791V97.1566H87.5557V96.3027H91.08V97.1566Z",
    fill: "#5B4F47"
  }))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_96"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M94.2449 100.049C94.2449 99.8439 94.1915 99.6883 94.0859 99.5816C93.9792 99.476 93.7862 99.3659 93.5046 99.25C92.9959 99.0593 92.6292 98.8345 92.4055 98.5733C92.1841 98.3133 92.0739 98.0056 92.0739 97.6514C92.0739 97.2245 92.225 96.8827 92.5281 96.625C92.8301 96.3649 93.2162 96.2344 93.6862 96.2344C93.9973 96.2344 94.2744 96.3002 94.5174 96.4297C94.7626 96.5602 94.95 96.7464 95.0805 96.9883C95.2134 97.2279 95.2804 97.4992 95.2804 97.8012H94.2585C94.2585 97.5651 94.2063 97.3857 94.1041 97.2608C94.0042 97.137 93.8588 97.0746 93.6681 97.0746C93.4887 97.0746 93.3479 97.1279 93.2457 97.2335C93.1458 97.3403 93.0958 97.4822 93.0958 97.6605C93.0958 97.8001 93.1515 97.9273 93.2639 98.042C93.3751 98.1544 93.5738 98.2713 93.8588 98.3917C94.355 98.5711 94.7149 98.7902 94.9397 99.0502C95.1634 99.3114 95.2758 99.6429 95.2758 100.045C95.2758 100.488 95.135 100.833 94.8534 101.08C94.5719 101.329 94.1881 101.453 93.7044 101.453C93.3774 101.453 93.0788 101.386 92.8097 101.253C92.5395 101.117 92.3283 100.924 92.1739 100.672C92.0217 100.421 91.9468 100.124 91.9468 99.7814H92.9777C92.9777 100.075 93.0334 100.289 93.1458 100.422C93.2605 100.556 93.4467 100.622 93.7044 100.622C94.0643 100.622 94.2449 100.431 94.2449 100.049Z",
    fill: "#5B4F47"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1385_144947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 109,
    fill: "white",
    transform: "translate(0.605957)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.40c20e04d27ac21d3cfa6952c0965409.svg";
export { ForwardRef as ReactComponent };